exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  padding-top: 50px; }\n  :host .navbar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    background: #07476d;\n    padding: 5px;\n    font-size: 25px; }\n    :host .navbar .title {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex; }\n      :host .navbar .title div:nth-child(1) {\n        color: #fff; }\n      :host .navbar .title div:nth-child(2) {\n        color: #337ab7; }\n    :host .navbar a {\n      margin-top: 5px;\n      color: white;\n      font-size: 15px; }\n      :host .navbar a:visited {\n        color: white; }\n  :host .content {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.scss
// module id = 474
// module chunks = 1